import { z } from 'zod';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { useTranslate } from 'src/locales';
import { useChannelContext } from 'src/pages/channel/hooks';

import { useConnectInstagram } from './useConnectInsta';

export function useInstagramStep2() {
  const { t } = useTranslate('translation');
  const { state, handleChannelName, handleFaceBookDeteail, onChangeStep } = useChannelContext();

  const schema = useMemo(
    () =>
      z.object({
        channelName: z.string().min(1, { message: t('CHANNEL_NAME_REQUIRED') }),
      }),
    [t]
  );

  type FormValues = z.infer<typeof schema>;

  const methods = useForm<FormValues>({
    mode: 'all',
    resolver: zodResolver(schema),
    defaultValues: { channelName: '' },
    values: { channelName: state.channelName },
  });

  const { handleSubmit, reset, watch, formState } = methods;

  const channelName = watch('channelName');

  const { connect, isInstagramConnectSuccess } = useConnectInstagram({
    onSuccess: handleFaceBookDeteail,
  });

  const onSubmit = handleSubmit((data) => {
    handleChannelName(data.channelName);
    reset();
    onChangeStep('next');
  });

  const isNextDisabled = !formState.isValid || !isInstagramConnectSuccess;
  const isConnectDisabled = !channelName;

  return {
    t,
    methods,
    channelName,
    isNextDisabled,
    isConnectDisabled,
    isInstagramConnectSuccess,
    connect,
    onSubmit,
  };
}
